import React, { useState } from "react";
import { MessageSquareHeart, Check } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";

export const ReviewForm = ({
  language = "es",
  prompt,
  namePlaceholder,
  placeholder,
  sendLabel,
  sendingLabel,
  thanksLabel,
}) => {
  const [name, setName] = useState("");
  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (!message.trim()) return;
    setSending(true);
    try {
      await api.post("/reviews", { name, message, language });
      setDone(true);
    } catch (e) {
      /* noop */
    } finally {
      setSending(false);
    }
  };

  if (done) {
    return (
      <div className="flex items-center gap-2 text-coastal-primary bg-coastal-primary/10 rounded-lg p-3 text-sm" data-testid="review-thanks">
        <Check size={16} /> {thanksLabel}
      </div>
    );
  }

  return (
    <div data-testid="review-form">
      <p className="flex items-center gap-2 text-coastal-text font-medium text-sm mb-2">
        <MessageSquareHeart size={16} className="text-coastal-accent" /> {prompt}
      </p>
      <Input
        data-testid="review-name"
        value={name}
        onChange={(e) => setName(e.target.value)}
        placeholder={namePlaceholder}
        className="mb-2 border-coastal-secondary"
      />
      <Textarea
        data-testid="review-message"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder={placeholder}
        className="border-coastal-secondary min-h-[80px]"
      />
      <Button
        data-testid="review-send-btn"
        onClick={submit}
        disabled={sending || !message.trim()}
        className="mt-2 w-full rounded-full bg-coastal-primary hover:bg-coastal-primary/90 text-white"
      >
        {sending ? sendingLabel : sendLabel}
      </Button>
    </div>
  );
};

export default ReviewForm;
